export default "__VITE_ASSET__BW4juKn5__"